import { atom } from "jotai";
import { nodesAtom, edgesAtom } from "@zapier/canvas-state";

import { fixAndParseJSON, zslOutlineToNodesAndEdges } from "../utils";

import { outlineAtom, partialOutlineAtom } from "./outlineAtom";

export const zslOutlineToNodesAndEdgesSetter = atom(null, (get, set) => {
  const partialOutlineData = get(partialOutlineAtom);
  const outlineData = get(outlineAtom);
  const shouldNotContinue = !partialOutlineData && !outlineData;
  if (shouldNotContinue) return;

  try {
    // if outlineData is empty, use partialOutlineData
    const parsedOutlineData = fixAndParseJSON(outlineData);
    const parsedPartialOutlineData = fixAndParseJSON(partialOutlineData);
    const parsedData =
      Object.keys(parsedOutlineData).length > 0
        ? parsedOutlineData
        : parsedPartialOutlineData;
    const { nodes, edges } = zslOutlineToNodesAndEdges(parsedData);
    set(nodesAtom, nodes);
    set(edgesAtom, edges);
  } catch (error) {
    console.error("Error streaming nodes and edges", error);
  }
});

zslOutlineToNodesAndEdgesSetter.debugLabel = "streamNodesAndEdgesCommand";
